import gql from 'graphql-tag';

export const CompositeEntity = gql`
mutation createCompositeEntity($input:CompositeEntityInput)
 {
    createCompositeEntity(input:$input) {
    graphTemplate
    isFormLevelOperationAllowed
    isReleaseAreaNotApplicable
    logicalEntityId
    multiEntityOrder
    isMenuRequired
    isNodeTreeRequired
    rootDataSetId
    configObjectId
    name
    configObjectType
    createdBy
    isDeleted
    itemDescription
    insert_ts
    projectId
    updatedBy
    update_ts
    deletionDate
        privileges{
            privilegeType
            roleId
            isDeleted
        }
        parentRelations
            {
              parentItemId
              relationType
              isDeleted
            }
          
        childRelations
            {
              childItemId
              relationType
              isDeleted
            }
          
    }
}
`;